import client from './client';

export interface FranchiseRecoveryIdentity {
  franchiseName: string;
  ownerName: string;
  phone: string;
}

function unwrap<T>(raw: any): T {
  if (raw.success === false) throw new Error(raw.error || '요청 실패');
  return (raw.data ?? raw) as T;
}

export async function requestPasswordOtp(
  identity: FranchiseRecoveryIdentity,
): Promise<{ maskedPhone: string }> {
  const res = await client.post('/api/password-recovery/franchise/request-otp', identity);
  return unwrap<{ maskedPhone: string }>(res.data);
}

export async function verifyPasswordOtp(
  identity: FranchiseRecoveryIdentity,
  otp: string,
  newPassword: string,
): Promise<{ success: true }> {
  const res = await client.post('/api/password-recovery/franchise/verify-otp', {
    ...identity,
    otp,
    newPassword,
  });
  return unwrap<{ success: true }>(res.data);
}
